/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetDogmaEffectsEffectIdNotFound
 */
export interface GetDogmaEffectsEffectIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetDogmaEffectsEffectIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetDogmaEffectsEffectIdNotFound interface.
 */
export function instanceOfGetDogmaEffectsEffectIdNotFound(value: object): value is GetDogmaEffectsEffectIdNotFound {
    return true;
}

export function GetDogmaEffectsEffectIdNotFoundFromJSON(json: any): GetDogmaEffectsEffectIdNotFound {
    return GetDogmaEffectsEffectIdNotFoundFromJSONTyped(json, false);
}

export function GetDogmaEffectsEffectIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDogmaEffectsEffectIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetDogmaEffectsEffectIdNotFoundToJSON(json: any): GetDogmaEffectsEffectIdNotFound {
    return GetDogmaEffectsEffectIdNotFoundToJSONTyped(json, false);
}

export function GetDogmaEffectsEffectIdNotFoundToJSONTyped(value?: GetDogmaEffectsEffectIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

